"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var StyledCheckBox_1 = __importDefault(require("../inputs/StyledCheckBox"));
var StyledCheckBoxField = function (_a) {
    var name = _a.name, label = _a.label;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    return (react_1.default.createElement(Field_1.default, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement(StyledCheckBox_1.default, { onChange: function (e) { return helpers.setValue(e.target.checked); }, checked: field.value }))));
};
StyledCheckBoxField.defaultProps = {
    label: undefined,
};
exports.default = StyledCheckBoxField;
